import { privateApi } from '@services/api';
import type {
  LevelResponse,
  LeaderboardResponse,
  JobsCountersResponse,
} from '@worker/types/worker-dashboard.type';
import type {
  FlipReview,
  FlipReviewsResponse,
} from '@th-types/flip-review.type';
import type {
  UpcomingJob,
  UpcomingJobsResponse,
} from '@th-types/upcoming-job.type';

const LEVEL_URL = 'level';
const LEADERBOARD_URL = 'leaderboard';
const FLIP_REVIEWS_URL = 'flip-reviews';
const UPCOMING_JOBS_URL = 'worker/jobs/upcoming';
const JOBS_COUNTERS_URL = 'worker/jobs/active/count';

export const getLevel = async (): Promise<LevelResponse> => {
  const result = await privateApi.get<LevelResponse>(LEVEL_URL);
  return result.data;
};

export const getLeaderboard = async (): Promise<LeaderboardResponse> => {
  const result = await privateApi.get<LeaderboardResponse>(LEADERBOARD_URL);
  return result.data;
};

export const getFlipReviews = async (): Promise<FlipReview[]> => {
  const result = await privateApi.get<FlipReviewsResponse>(FLIP_REVIEWS_URL);
  return result.data.flipReviews;
};

export const markFlipReviewHelpful = async (id: number): Promise<void> => {
  await privateApi.post(`${FLIP_REVIEWS_URL}/${id}/helpful`);
};

export const markFlipReviewUnhelpful = async (id: number): Promise<void> => {
  await privateApi.post(`${FLIP_REVIEWS_URL}/${id}/unhelpful`);
};

export const getUpcomingJobs = async (max = 5): Promise<UpcomingJob[]> => {
  const result = await privateApi.get<UpcomingJobsResponse>(
    `${UPCOMING_JOBS_URL}?max=${max}`
  );
  return result.data.jobs;
};

export const getJobsCounters = async (): Promise<JobsCountersResponse> => {
  const result = await privateApi.get<JobsCountersResponse>(JOBS_COUNTERS_URL);
  return result.data;
};
